import * as Yup from "yup";

export const myProfileAccounValidator = (prevData, type) => {
  if (type === "initialValues") {
    let initialValues = {
      fname: prevData?.fname ?? "",
      lname: prevData?.lname ?? "",
      email: prevData?.email ?? "",
      phoneNumber: prevData?.phoneNumber ?? "",
      countryCode: prevData?.countryCode ?? "+65",
      property_type: prevData?.customer?.property_type ?? "",
      dob: prevData?.customer?.dob ?? new Date(),
    };
    return initialValues;
  } else if (type === "validationSchema") {
    const specialCharRestrict = "^[A-Za-z0-9 ]+$";
    let validationSchema = Yup.object().shape({
      fname: Yup.string()
        .required("This field is required.")
        .matches(specialCharRestrict, {
          message: "Special character not allowed",
        }),
      lname: Yup.string()
        .required("This field is required.")
        .matches(specialCharRestrict, {
          message: "Special character not allowed",
        }),
      phoneNumber: Yup.string().required("This field is required."),
      property_type: Yup.string().required("This field is required."),
      dob: Yup.string().required("This field is required."),
      //   countryCode: Yup.string()
      //     .required("This field is required.")
      //     .matches(countryCode, { message: "Max 2 digit required" }),
      email: Yup.string().email().required("This field is required"),
    });
    return validationSchema;
  }
};
export const myProfileAddValidator = (prevData, type) => {
  if (type === "initialValues") {
    let initialValues = {
      postalCode: prevData?.postalCode ?? "",
      country: prevData?.country ?? "",

      // generalLocation: "",
      title: prevData?.title ?? "",
      unitNo: prevData?.unitNo ?? "",
    };
    return initialValues;
  } else if (type === "validationSchema") {
    let validationSchema = Yup.object().shape({
      // postalCode: Yup.string().required("Postal code is required"),
      // country: Yup.string().required("Country is required"),
      title: Yup.string().required("Address name is required"),
    });
    return validationSchema;
  }
};
